module.exports = __webpack_public_path__ + "static/media/video2.f7d2e014.png";